module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/news/news.component.css
// module id = ./src/app/components/news/news.component.css
// module chunks = main